exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-link[data-v-a7459cf4]{position:absolute;top:0;left:0;opacity:.5}.index-link[data-v-a7459cf4]:hover{opacity:1}.index-link a[data-v-a7459cf4]{display:block;color:gray;text-decoration:none;background:#f9f9f9;padding:10px 20px;font-size:15px;border-bottom-right-radius:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a7459cf4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layout/DebugIndexLink.vue
// module id = 121
// module chunks = 0